
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"30 0 570 570","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M350 35a245.006 245.006 0 00-173.24 71.758 245.02 245.02 0 00-71.758 173.24c0 64.97 25.812 127.29 71.758 173.24 45.949 45.945 108.27 71.758 173.24 71.758s127.29-25.812 173.24-71.758a245.02 245.02 0 0071.758-173.24 245.04 245.04 0 00-71.773-173.23 245.027 245.027 0 00-173.23-71.773zm-61.25 350a17.498 17.498 0 01-26.25 15.156A17.499 17.499 0 01253.75 385V175a17.549 17.549 0 0117.5-17.5h52.5c18.566-.004 36.375 7.368 49.504 20.496s20.5 30.938 20.496 49.504V315a17.498 17.498 0 01-26.25 15.156A17.499 17.499 0 01358.75 315v-87.5a35.106 35.106 0 00-35-35h-35zm157.5-52.5c.004 18.566-7.367 36.375-20.496 49.504s-30.938 20.5-49.504 20.496h-52.5a17.549 17.549 0 01-17.5-17.5V245a17.498 17.498 0 0126.25-15.156A17.499 17.499 0 01341.25 245v122.5h35a35.106 35.106 0 0035-35V175a17.498 17.498 0 0126.25-15.156A17.499 17.499 0 01446.25 175z"}})])
          )
        }
      }
    